import { BlockViewExtension } from '@blocksuite/affine/block-std';
import type { ExtensionType } from '@blocksuite/affine/store';
import { literal } from 'lit/static-html.js';

export const AgentStagesBlockSpec: ExtensionType[] = [
  BlockViewExtension('affine:agent-stages', () => literal`affine-agent-stages`),
];
